module.exports = __webpack_public_path__ + "img/f3a02b3.svg";